import { z } from 'zod';
/** The choices a rider sees, as a share of the fare. */
export const TIP_PERCENTS = [15, 20, 25];
export const TIP_MIN_CENTS = 100;
/** A tip can never pass this, whatever the fare. */
const TIP_CEILING_CENTS = 50_000;
/** How long after a ride a tip can still be added. */
export const TIP_WINDOW_DAYS = 30;
/** The most a tip can be: the fare or $50, whichever is more. It stops a slipped finger, and stolen cards being cashed out as tips. */
export function tipMaxCents(fareCents) {
    return Math.min(TIP_CEILING_CENTS, Math.max(fareCents ?? 0, 5_000));
}
/** 15, 20 and 25% of the fare in whole dollars; a ride with no fare gets only the rider's own amount. */
export function tipSuggestions(fareCents) {
    if (!fareCents)
        return [];
    return TIP_PERCENTS.map((percent) => ({ percent, cents: Math.max(TIP_MIN_CENTS, Math.round((fareCents * percent) / 10_000) * 100) }));
}
export const TipInputSchema = z.object({ amountCents: z.number().int().min(1).max(TIP_CEILING_CENTS) });
//# sourceMappingURL=tips.js.map